/**
 * FilterBar Component
 * Container for filter controls (dropdowns, tabs, search inputs).
 * Wraps children in a responsive flex row.
 */

import { ReactNode } from 'react';
import styled from 'styled-components';

export interface FilterBarProps {
  children: ReactNode;
}

const Bar = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[3]};
  flex-wrap: wrap;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    gap: ${({ theme }) => theme.spacing[2]};
  }
`;

export function FilterBar({ children }: FilterBarProps) {
  return <Bar role="search" aria-label="Task filters">{children}</Bar>;
}

export default FilterBar;
